import React from 'react';
import { Messaging } from 'oskari-ui/util';
import { ObjectData } from './components/ObjectData';
var getFileId = function getFileId(file) {
  return file._$layerId + '||' + (file._oid || file.__fid);
};
export var showMessage = function showMessage(file) {
  Messaging.open({
    title: 'Ladattava kohde',
    content: /*#__PURE__*/React.createElement(ObjectData, {
      item: file
    })
  });
};
var selectedFiles = {};
var listeners = [];
var notify = function notify() {
  listeners.forEach(function (l) {
    return l();
  });
};
export var Basket = {
  add: function add(file) {
    selectedFiles[getFileId(file)] = file;
    notify();
  },
  isInBasket: function isInBasket(file) {
    return !!selectedFiles[getFileId(file)];
  },
  list: function list() {
    return Object.values(selectedFiles);
  },
  remove: function remove(file) {
    delete selectedFiles[getFileId(file)];
    notify();
  },
  clear: function clear(layer) {
    var keys = Object.keys(selectedFiles);
    keys.filter(function (key) {
      return !layer || key.startsWith(layer + '||');
    }).forEach(function (key) {
      delete selectedFiles[key];
    });
    notify();
  },
  onChange: function onChange(listener) {
    return listeners.push(listener);
  }
};